import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import type { ActivityDetailsProps } from './types.ts'
import { Link } from '../index.ts'
import { ActivityTrans } from '../activity-trans.tsx'

export const ProjectServiceAdded = ({
  activity: {
    person,
    details: {
      activityType,
      data: { project, service },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_service_added'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{
            subject: getPersonFullName(person),
            projectName: project.name,
            serviceName: service.name,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Link {...{ target: project, t, onNavigate, currentUrl }} />
      </Feed.Annotations>
    </>
  )
